export const classSectionEntryApi = {
    heading:[
        {
            head:"Campus Name"
        },
        {
            head:"Class"
        },
        {
            head:"Section"
        },
        {
            head:"Teacher"
        },
        {
            head:"Shift"
        },
        {
            head:"Start Time"
        },
        {
            head:"End Time"
        },
        {
            head:"Action"
        },
        {
            head:"Delete"
        }
    ],
    data:[
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png",
            delete:"assets/images/dashboards/adminDashboard/icon/tabledeleteicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png",
            delete:"assets/images/dashboards/adminDashboard/icon/tabledeleteicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png",
            delete:"assets/images/dashboards/adminDashboard/icon/tabledeleteicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png",
            delete:"assets/images/dashboards/adminDashboard/icon/tabledeleteicon.png"
        },
     
       
    ]
}